import {
  CommandsCategory,
  CommandsMPOperation,
  CommandsOperation,
  CommandsParams,
  CommandsTSCOperation,
} from '@src/types/Commands';

function useGetCommands(
  category: CommandsCategory,
  operation: CommandsOperation,
  params: CommandsParams = {},
): string | null {
  if (category === CommandsCategory.TSC) {
    switch (operation as CommandsTSCOperation) {
      case 'Enable':
        return 'Start Unit';
      case 'Disable':
        return 'Stop Unit';
      case 'Power':
        return `Power::${params.P}::${params.Q}`;
      case 'WriteToVariant':
        return `WriteToVariant::${params.P}`;
      default:
        return null;
    }
  }

  if (category === CommandsCategory.MP) {
    switch (operation as CommandsMPOperation) {
      case 'OpenBreaker':
        return `Open AC Breaker::${params.MP}`;
      case 'CloseBreaker':
        return `Close AC Breaker::${params.MP}`;
      case 'DisableMegapack':
        return `Open DC Contactor::${params.MP}`;
      case 'ClearDisableMegapack':
        return `Close DC Contactor::${params.MP}`;
      default:
        return null;
    }
  }

  return null;
}

export default useGetCommands;
